The opaque cursor to the position profile.

This can be used as a subsequent pagination argument.
